import Cookie from 'js-cookie'

export default {
  namespaced: true,
  state: {
    profile: null,
    loggedIn: !!Cookie.get('access_token'),
    hasRefreshToken: !!Cookie.get('refresh_token'),
    isRefreshed: false
  },

  getters: {
    profile: state => state.profile,
    loggedIn: state => state.loggedIn,
    hasRefreshToken: state => state.hasRefreshToken,
    isRefreshed: state => state.isRefreshed
  },

  mutations: {
    SET_PROFILE: (state, payload = null) => {
      state.profile = payload
      state.loggedIn = !!payload
    },
    SET_PROFILE_PERMISSIONS: (state, payload = null) => {
      state.permissions = payload
    },
    SET_REFRESHED: (state, payload = false) => {
      state.isRefreshed = payload
    }
  },

  actions: {
    LOGIN: async function ({ commit }, payload) {
      const { data } = await this.$api.auth.login(payload)
      this.resetJWT(data.token)

      commit('SET_PROFILE', data)
    },

    RESET_PROFILE: async function ({ commit }) {
      commit('SET_PROFILE')
      commit('SET_PROFILE_PERMISSIONS')
      this.removeJWT()
    },

    // eslint-disable-next-line no-unused-vars
    REFRESH_TOKEN: async function ({ dispatch }, payload) {
      const { data } = await this.$api.auth.refreshToken(payload)
      this.resetJWT(data)
      await dispatch('GET_PROFILE')
    },

    LOGOUT: async function ({ commit }) {
      this.removeJWT()
      commit('SET_PROFILE')
    },

    GET_PROFILE: async function ({ commit }) {
      const { data } = await this.$api.auth.profile()
      commit('SET_PROFILE', data)
    }
  }
}
